const handler = ( $ ) => {

	/**
	 * Close modal window
	 */
	$('.modal-close').on( 'click', function( e ) {
		e.preventDefault();

		$('body').trigger('before-modal-closed');
		$(this).parents( '.modal').fadeOut('fast', function() {
			$('body').removeClass('is-modal-open').trigger('is-modal-closed');
		});
		

	});

	/**
	 * Close modal window by clicking outside
	 */
	$('.modal-backdrop').on( 'click', function( e ) {
		if( $( e.target).closest( '.modal-inner').length === 0) {

			$('body').trigger('before-modal-closed');
			$(this).parents( '.modal').fadeOut('fast', function() {
				$('body').removeClass('is-modal-open').trigger('is-modal-closed');
			});
			
		}
	});

	/**
	 * Open modal window
	 */
	$('.open-modal').on( 'click', function( e ) {
		e.preventDefault();

		const $modal = $( $(this).attr('href') );

		if( $modal.length ) {

			$('body').trigger('before-modal-open');
			$modal.fadeIn('fast', function() {
				$('body').addClass('is-modal-open').trigger('is-modal-open');
			});

		}

	})

};

export default ( ( $ ) => $( handler ) )( jQuery );
